export const ecdServiceSteps = [
  { id: 'ServiceDetails', name: 'Service Details' },
  { id: 'ServiceContacts', name: 'Service Contacts' },
  { id: 'RegistrationManagement', name: 'Registration Management' },
];

export const ecdRegistrationSteps = [
  { id: 'Application', name: 'Application' },
  { id: 'Framework', name: 'Framework' },
  { id: 'Assessment', name: 'Assessments' },
  { id: 'Complete', name: 'Complete' },
];

export const ECD_INITIAL_VALUES = {
  id: '',
  stepApplication: {
    identifiedBy: '',
    dateIdentified: new Date(),
    sspSupervisorId: '',
    socialServicesProfessionalId: '',
  },
  stepFramework: {},
  stepAssessment: {},
  stepApproval: {},
};
